/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * BFF hotel
 * This is the API for the portal frontend and serves as the gateway to the hotel context backend services.
 * OpenAPI spec version: 1.2.0
 */
import { adapter } from './adapter';
export interface HotelRecommendationsCategory {
  type?: string;
  value?: number;
}

export interface HotelRecommendationsCatering {
  code?: string;
}

export interface HotelRecommendationsRating {
  description?: string;
  score?: number;
}

export interface HotelRecommendationsRoom {
  code?: string;
}

export interface PricedHotelMetaCategories {
  category1?: HotelCategoryItem;
  category2?: HotelCategoryItem;
  category3?: HotelCategoryItem;
  category4?: HotelCategoryItem;
  category5?: HotelCategoryItem;
}

export interface PricedHotelMetaRatings {
  excellent?: HotelCategoryItem;
  fair?: HotelCategoryItem;
  good?: HotelCategoryItem;
  poor?: HotelCategoryItem;
  very_good?: HotelCategoryItem;
}

export interface PricedHotelMetaRegion {
  id: string;
  name: string;
  /** @minimum 1 */
  count: number;
  /** @minItems 0 */
  children?: PricedHotelMetaRegion[];
}

export interface PricedHotelMetaTourOperatorSpecials {
  flex?: TourOperatorSpecialCategoryHotels;
  safety?: TourOperatorSpecialCategoryHotels;
  specials?: TourOperatorSpecialCategoryHotels;
}

export interface Airline {
  code: string;
  name: string;
}

export interface Airport {
  city: string;
  iata: string;
  name: string;
}

export type AttributesGroupItems = {[key: string]: HotelCategoryItem};

export interface AttributesGroup {
  items?: AttributesGroupItems;
}

export interface BoundFlight {
  airline: Airline;
  arrival: FlightInfo;
  cabinClass: string;
  changeOfDate: number;
  departure: FlightInfo;
  directFlightAssumed: boolean;
  duration: number;
  handLuggage?: Luggage;
  luggage?: Luggage;
  numberOfStops: number;
  segments: FlightSegment[];
}

export interface CancellationRule {
  /** fee for cancellation in cent */
  price: number;
  priceDisplay: PriceWithCurrency;
  /** type of cancellation rule (coming from specials, expedia etc.) */
  ruleType: string;
  tmpPrice: PriceWithCurrency;
  /** cancellation is possible until this date and time */
  validTo: string;
}

export interface CommonOfferRoom {
  adults?: number;
  /** ordered attributes of the room - view, pool, balcony... */
  attributes: InviaType[];
  boardType?: InviaType;
  children: number[];
  handicapped_accessible: boolean;
  roomCode?: string;
  supplierType?: string;
  type?: InviaType;
  view: InviaTypeOptional;
}

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountType = {
  NO_DISCOUNT: 'NO_DISCOUNT',
  SPECIAL_DISCOUNT: 'SPECIAL_DISCOUNT',
  ISEARCH_DISCOUNT: 'ISEARCH_DISCOUNT',
  PRICE_CACHE: 'PRICE_CACHE',
} as const;

export interface Sponsored {
  impressionUrl: string;
  viewableImpressionUrl: string;
  conversionUrl: string;
  clickUrl: string;
  flightId: number;
  creativeContent?: CreativeContent;
}

/**
 * additional content - only for offers
 */
export interface CreativeContent {
  companionText: string;
  tourOperator: string;
}

export interface FlightInfo {
  airport?: Airport;
  /**
   * ISO_8601 representation of date/time
   * @nullable
   */
  date?: string | null;
}

export interface FlightSegment {
  airline?: Airline;
  arrival?: FlightInfo;
  cabinClass?: string;
  changeOfDate?: number;
  departure?: FlightInfo;
  duration?: number;
  flightNumber?: string;
}

export interface HotelCategoryItem {
  count: number;
  price: number;
  priceDisplay: PriceWithCurrency;
}

export interface HotelImages {
  hotelId: string;
  /** @minItems 0 */
  images: Image[];
}

export type HotelInventoryCategoryName = typeof HotelInventoryCategoryName[keyof typeof HotelInventoryCategoryName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotelInventoryCategoryName = {
  ROOMCODE: 'ROOMCODE',
  BOARDCODE: 'BOARDCODE',
  TOUROPERATOR: 'TOUROPERATOR',
  DURATION: 'DURATION',
  ROOMVIEW: 'ROOMVIEW',
  TRANSFER: 'TRANSFER',
  ROOMATTRIBUTE: 'ROOMATTRIBUTE',
} as const;

export interface HotelInventoryCategory {
  name: HotelInventoryCategoryName;
  variations: HotelInventoryVariation[];
}

export interface HotelInventoryVariation {
  count: number;
  value: string;
}

export interface HotelRecommendations {
  category?: HotelRecommendationsCategory;
  catering?: HotelRecommendationsCatering;
  city?: string;
  duration?: number;
  foreignCurrencies?: PriceCurrency[];
  hotelID?: string;
  link?: string;
  name?: string;
  price?: PriceCurrency;
  priceDisplay?: PriceWithCurrency;
  rating?: HotelRecommendationsRating;
  recoTag?: string;
  region?: string;
  room?: HotelRecommendationsRoom;
  teaserImage?: string;
}

/**
 * predicted special types for the hotel (real specials can only be given to an offer)
 */
export interface HotelSpecialItem {
  filterName?: string;
  type?: string;
  hint?: string;
}

export interface HotelSpecials {
  flex: HotelSpecialItem[];
  safety: HotelSpecialItem[];
  specials: HotelSpecialItem[];
}

export interface Image {
  large: ImageUrl;
  small: ImageUrl;
  categoryCodes?: string[];
}

export interface ImageUrl {
  /** full url to the image, page or whatever */
  url: string;
}

export type InventoryCategoryName = typeof InventoryCategoryName[keyof typeof InventoryCategoryName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InventoryCategoryName = {
  ROOMCODE: 'ROOMCODE',
  BOARDCODE: 'BOARDCODE',
  TOUROPERATOR: 'TOUROPERATOR',
  DURATION: 'DURATION',
  ROOMVIEW: 'ROOMVIEW',
  TRANSFER: 'TRANSFER',
  AIRLINE: 'AIRLINE',
} as const;

export interface InventoryCategory {
  name: InventoryCategoryName;
  variations: InventoryVariation[];
}

export interface InventoryVariation {
  /** @deprecated */
  price: number;
  priceDisplay?: PriceWithCurrency;
  value: string;
}

/**
 * single item with inviaType and translation
 */
export interface InviaType {
  name: string;
  type: string;
}

/**
 * single item with inviaType and translation
 */
export interface InviaTypeOptional {
  name?: string;
  type?: string;
}

export interface RoomUpgrade {
  roomType?: string[];
  description?: string[];
  boardType?: string[];
  attributes?: string[];
}

export interface Upgrades {
  roomUpgrade?: RoomUpgrade[];
  transportations?: string[];
  tourOperatorSpecials?: string[];
}

export interface Luggage {
  dimension?: string;
  weight?: number;
}

export interface Price {
  Display?: PriceWithCurrency;
  Pay?: PriceWithCurrency;
  /** possible types are ADULT, CHILD, ALL (for person price) */
  type?: string;
  value: number;
}

export interface PriceChartItem {
  betweenDeparturesDuration: number;
  boardType?: InviaTypeOptional;
  departureAirport?: Airport;
  /** use betweenDeparturesDuration and overnightStays */
  duration: number;
  endDate: string;
  overnightStays: number;
  room?: PriceChartItemRoom;
  rooms: PriceChartItemRoom[];
  startDate: string;
  tmpTotalPrice: PriceWithCurrency;
  totalPrice: number;
  totalPriceDisplay: PriceWithCurrency;
}

export interface PriceChartItemRoom {
  boardType?: InviaTypeOptional;
  supplierType: string;
  type?: InviaTypeOptional;
  view?: InviaTypeOptional;
}

export interface PriceCurrency {
  currency?: string;
  value?: number;
}

export interface PriceForDate {
  /**
   * RFC3339 representation of full-date (YYYY-MM-DD) when the payment has to be done, an empty date means immediately
   * @nullable
   */
  date?: string | null;
  /** Price in EUR cent */
  price: number;
  priceDisplay: PriceWithCurrency;
  tmpPrice: PriceWithCurrency;
}

export interface PriceRange {
  max: number;
  maxDisplay: PriceWithCurrency;
  min: number;
  minDisplay: PriceWithCurrency;
}

export interface PriceWithCurrency {
  amount: number;
  currency: string;
}

export interface PricedHotel {
  id: string;
  lat: number;
  lon: number;
  /** use totalPrice (just renaming) */
  price: number;
  rating?: Rating;
  rooms: CommonOfferRoom[];
  tmpTotalDiscount: PriceWithCurrency;
  tmpTotalPrice: PriceWithCurrency;
  tmpTotalPriceOriginal: PriceWithCurrency;
  /** discount that belongs to the explicit offer in the hotel */
  totalDiscount: number;
  totalDiscountDisplay: PriceWithCurrency;
  /** a descriptive hint for the discount */
  totalDiscountHint?: string;
  /** total price of the hotel offer */
  totalPrice: number;
  totalPriceDisplay: PriceWithCurrency;
  /** total price without discounts */
  totalPriceOriginal: number;
  totalPriceOriginalDisplay: PriceWithCurrency;
  tourOperatorSpecials: HotelSpecials;
  travelDateInfo?: TravelDateInfo;
  /**
   * discount percentage in price (0-100)
   * @minimum 0
   * @maximum 100
   */
  discountPercentage: number;
  discountType: DiscountType;
  sponsored?: Sponsored;
}

export type PricedHotelMetaAttributes = {[key: string]: AttributesGroup};

export interface PricedHotelMeta {
  attributes?: PricedHotelMetaAttributes;
  categories?: PricedHotelMetaCategories;
  priceRange?: PriceRange;
  ratings?: PricedHotelMetaRatings;
  /** @minItems 0 */
  regions?: PricedHotelMetaRegion[];
  totalCount?: number;
  tourOperatorSpecials?: PricedHotelMetaTourOperatorSpecials;
}

export interface Room {
  adults: number;
  children?: number[];
  roomType?: string[];
  boardType?: string[];
}

export type TourOperatorSpecialCategoryAllOf = {
  variations: TourOperatorSpecialVariation[];
};

export type TourOperatorSpecialCategory = TourOperatorSpecialCategoryCommon & TourOperatorSpecialCategoryAllOf;

export interface AirlineCounts {
  airlineCode?: string;
  price?: PriceWithCurrency;
}

export interface ArrivalAirportCounts {
  airportCode: string;
  price: PriceWithCurrency;
  /** @nullable */
  lat: number | null;
  /** @nullable */
  lon: number | null;
}

export interface RoomAttributesCounts {
  type?: string;
  price?: PriceWithCurrency;
}

/**
 * called group in all other places
 */
export type TourOperatorSpecialCategoryCommonType = typeof TourOperatorSpecialCategoryCommonType[keyof typeof TourOperatorSpecialCategoryCommonType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TourOperatorSpecialCategoryCommonType = {
  flex: 'flex',
  specials: 'specials',
  safety: 'safety',
} as const;

export interface TourOperatorSpecialCategoryCommon {
  tooltip?: string;
  /** called group in all other places */
  type?: TourOperatorSpecialCategoryCommonType;
}

export type TourOperatorSpecialCategoryHotelsAllOf = {
  translation?: string;
  variations?: TourOperatorSpecialVariationHotels[];
};

export type TourOperatorSpecialCategoryHotels = TourOperatorSpecialCategoryCommon & TourOperatorSpecialCategoryHotelsAllOf;

export interface TourOperatorSpecialVariation {
  tooltip?: string;
  tourOperators: string[];
  type: string;
}

export type TourOperatorSpecialVariationHotelsAllOf = {
  count: number;
  price: number;
  priceDisplay: PriceWithCurrency;
  tourOperators?: string[];
  translation: string;
};

/**
 * specials meta with additional counts and min price
 */
export type TourOperatorSpecialVariationHotels = TourOperatorSpecialVariation & TourOperatorSpecialVariationHotelsAllOf;

export interface TravelDateInfo {
  /** use stays and overnightStays */
  duration?: number;
  endDate?: string;
  /** count of nights */
  overnightStays?: number;
  startDate?: string;
  /** pt: betweenDepartureDuration +1 in days, oa: duration with arrivalDay and departureDay in days */
  stays?: number;
}

export type RatingRatingType = typeof RatingRatingType[keyof typeof RatingRatingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RatingRatingType = {
  TRUSTYOU: 'TRUSTYOU',
  AMADEUS: 'AMADEUS',
} as const;

export interface Rating {
  /** rating value */
  rating: number;
  count: number;
  /** percentage value of recommendations */
  recommendationRate: number;
  ratingType: RatingRatingType;
}

/**
 * Delivers the lowest price of a search from, and a link to _invia.de_ for the cross border sales project.
 */
export interface CrossBorders {
  priceTotal: PriceWithCurrency;
  /** URL to the respective invia.de page. */
  url: string;
  /**
   * Departure airports set in the invia.de search.
   * @minItems 0
   */
  airports: string[];
}

export type RecommendationsResponseTranslations = {[key: string]: string};

/**
 * defines a successful recommendations response.
 */
export interface RecommendationsResponse {
  /** @minItems 0 */
  hotels: HotelRecommendations[];
  translations?: RecommendationsResponseTranslations;
  /** json string with additional data to track */
  info?: string;
}

export type HotelsResponseTranslations = {[key: string]: string};

export interface HotelsResponse {
  hotels?: PricedHotel[];
  initialMeta?: PricedHotelMeta;
  meta?: PricedHotelMeta;
  translations?: HotelsResponseTranslations;
  crossBorders?: CrossBorders;
}

export type HotelInventoryResponseTranslations = {[key: string]: string};

export interface HotelInventoryResponse {
  /** @minItems 0 */
  categories?: HotelInventoryCategory[];
  /** @minItems 0 */
  initialCategories?: HotelInventoryCategory[];
  translations?: HotelInventoryResponseTranslations;
}

/**
 * a generic bad request error
 */
export interface BadRequestResponse {
  message: string;
}

/**
 * contains some detailed error information.
 */
export interface ErrorDetail {
  /** the error code. */
  code: number;
  /** the error message. use only for internal evaluation. */
  message: string;
  /**
   * describes a field or parameter this error belongs to. may be null.
   * @nullable
   */
  relate: string | null;
}

/**
 * the container to return error information.
 */
export interface ErrorResponse {
  /** the error code. */
  code: number;
  /** the error message. use only for internal evaluation. */
  message: string;
  'error-details': ErrorDetail[];
}

/**
 * An error response
 */
export type ErrorResponseResponse = ErrorResponse;

/**
 * A bad request response
 */
export type BadRequestResponseResponse = BadRequestResponse;

/**
 * defines the count of adult persons during the travel. deprecated -> use rooms
 * @deprecated
 */
export type AdultsParameter = number;

/**
 * defines a list of airports.
 */
export type AirportsParameter = string[];

/**
 * defines a list of airports for the outbound flights arrival.
 */
export type ArrivalAirportsParameter = string[];

/**
 * defines the filter for board types.
 */
export type BoardTypesParameter = string[];

/**
 * defines the minimum category for the whole travel.
 */
export type CategoryMinParameter = number | null;

/**
 * defines the count of children during the travel.
 */
export type ChildrenParameter = number[];

/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 */
export type DateMaxParameter = string;

/**
 * defines the first day of vacation.
 */
export type DateMinParameter = string;

/**
 * defines the region id from autocompleter.
 */
export type DestinationIdParameter = string;

/**
 * filter for sub-regions of the provided DestinationId, value is a region id from autocompleter.
 */
export type DestinationIdFilterParameter = string;

/**
 * filtered Duration
 */
export type DurationFilterParameter = number | null;

/**
 * maximum duration of travel
 */
export type DurationMaxParameter = number | null;

/**
 * minimum duration of travel
 */
export type DurationMinParameter = number | null;

/**
 * filter hotel attributes like pool,bar,parking lot
 */
export type HotelAttributesParameter = string[];

/**
 * Should be set if the response should contain meta data for an unfiltered request - for the initial (first) call from the frontend to know all possible filter options
 */
export type InitialParameter = boolean;

/**
 * name of portal to distinguish agents
 */
export type PortalAgentParameter = string;

/**
 * maximum price of whole travel in the displayCurrency (defined in vault for each whitelabel)
 */
export type PriceMaxParameter = number | null;

/**
 * minimum price of whole travel in the displayCurrency (defined in vault for each whitelabel)
 */
export type PriceMinParameter = number | null;

/**
 * minimum rating as float of whole travel
 */
export type RatingMinParameter = number | null;

export type RatingTypeParameter = typeof RatingTypeParameter[keyof typeof RatingTypeParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RatingTypeParameter = {
  ratingTrustYou: 'ratingTrustYou',
  ratingAmadeus: 'ratingAmadeus',
} as const;

/**
 * defines the count of adult persons during the travel.
 */
export type RecomAdultsParameter = number;

export type RoomsParameter = {[key: string]: Room};

/**
 * filter room types
 */
export type RoomTypesParameter = string[];

/**
 * filter room view types
 * @deprecated
 */
export type RoomViewsParameter = string[];

/**
 * filter hotels or offer by special types
 */
export type SpecialsParameter = string[];

/**
 * position of sponsored hotels in hotelList - 1 means first position in list
 */
export type SponsoredHotelsParameter = number[];

/**
 * defines a list of tour operators.
 */
export type TourOperatorsParameter = string[];

/**
 * search/filter for hotel transfer from and to airport, train to the airport (RailAndFly), direct flight or rental car
 */
export type TransportationsParameter = string[];

export type TravelTypeParameter = typeof TravelTypeParameter[keyof typeof TravelTypeParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TravelTypeParameter = {
  packageTour: 'packageTour',
  ownArrival: 'ownArrival',
} as const;

/**
 * search for offers with specific attributes on the rooms
 */
export type FilterRoomAttributesParameter = string[];

/**
 * uuid, identifying the user without knowing his name
 */
export type XUserIdParameter = string;

export type GetHotelInventoryParams = {
/**
 * defines the region id from autocompleter.
 */
destinationId: DestinationIdParameter;
/**
 * filter for sub-regions of the provided DestinationId, value is a region id from autocompleter.
 */
destinationIdFilter?: DestinationIdFilterParameter;
/**
 * maximum price of whole travel in the displayCurrency (defined in vault for each whitelabel)
 */
priceMax?: PriceMaxParameter;
/**
 * defines the minimum category for the whole travel.
 */
categoryMin?: CategoryMinParameter;
/**
 * minimum rating as float of whole travel
 */
ratingMin?: RatingMinParameter;
/**
 * which rating type should be used for filtering, sorting ...
 */
ratingType?: RatingTypeParameter;
/**
 * filter hotel attributes like pool,bar,parking lot
 */
hotelAttributes?: HotelAttributesParameter;
/**
 * filter room types
 */
roomTypes?: RoomTypesParameter;
/**
 * defines the filter for board types.
 */
boardTypes?: BoardTypesParameter;
/**
 * filter room view types
 * @deprecated
 */
roomViews?: RoomViewsParameter;
/**
 * defines the first day of vacation.
 */
dateMin: DateMinParameter;
/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 */
dateMax: DateMaxParameter;
/**
 * defines a list of airports.
 */
airports?: AirportsParameter;
/**
 * minimum duration of travel
 */
durationMin?: DurationMinParameter;
/**
 * maximum duration of travel
 */
durationMax?: DurationMaxParameter;
/**
 * filtered Duration
 */
durationFilter?: DurationFilterParameter;
/**
 * defines the travel type.
 */
travelType?: TravelTypeParameter;
/**
 * defines a list of tour operators.
 */
tourOperators?: TourOperatorsParameter;
/**
 * Should be set if the response should contain meta data for an unfiltered request - for the initial (first) call from the frontend to know all possible filter options
 */
initial?: InitialParameter;
/**
 * search/filter for hotel transfer from and to airport, train to the airport (RailAndFly), direct flight or rental car
 */
transportations?: TransportationsParameter;
/**
 * filter hotels or offer by special types
 */
specials?: SpecialsParameter;
/**
 * distribution of rooms to multiroom
 */
rooms: RoomsParameter;
/**
 * search for offers with specific attributes on the rooms
 */
roomAttributes?: FilterRoomAttributesParameter;
};

export type GetHotelsParams = {
/**
 * defines the region id from autocompleter.
 */
destinationId: DestinationIdParameter;
/**
 * filter for sub-regions of the provided DestinationId, value is a region id from autocompleter.
 */
destinationIdFilter?: DestinationIdFilterParameter;
offset?: number;
limit?: number;
sortBy?: GetHotelsSortBy;
/**
 * maximum price of whole travel in the displayCurrency (defined in vault for each whitelabel)
 */
priceMax?: PriceMaxParameter;
/**
 * minimum price of whole travel in the displayCurrency (defined in vault for each whitelabel)
 */
priceMin?: PriceMinParameter;
/**
 * defines the minimum category for the whole travel.
 */
categoryMin?: CategoryMinParameter;
/**
 * minimum rating as float of whole travel
 */
ratingMin?: RatingMinParameter;
/**
 * which rating type should be used for filtering, sorting ...
 */
ratingType?: RatingTypeParameter;
/**
 * filter hotel attributes like pool,bar,parking lot
 */
hotelAttributes?: HotelAttributesParameter;
/**
 * filter room types
 */
roomTypes?: RoomTypesParameter;
/**
 * defines the filter for board types.
 */
boardTypes?: BoardTypesParameter;
/**
 * filter room view types
 * @deprecated
 */
roomViews?: RoomViewsParameter;
/**
 * defines the first day of vacation.
 */
dateMin: DateMinParameter;
/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 */
dateMax: DateMaxParameter;
/**
 * defines a list of airports.
 */
airports?: AirportsParameter;
/**
 * minimum duration of travel
 */
durationMin?: DurationMinParameter;
/**
 * maximum duration of travel
 */
durationMax?: DurationMaxParameter;
/**
 * filtered Duration
 */
durationFilter?: DurationFilterParameter;
/**
 * defines the travel type.
 */
travelType?: TravelTypeParameter;
/**
 * defines a list of tour operators.
 */
tourOperators?: TourOperatorsParameter;
/**
 * Should be set if the response should contain meta data for an unfiltered request - for the initial (first) call from the frontend to know all possible filter options
 */
initial?: InitialParameter;
/**
 * distribution of rooms to multiroom
 */
rooms: RoomsParameter;
/**
 * userID getting from BD4Travel Cookie - for sorting hotel list
 */
BD4ID?: string;
/**
 * search/filter for hotel transfer from and to airport, train to the airport (RailAndFly), direct flight or rental car
 */
transportations?: TransportationsParameter;
/**
 * filter hotels or offer by special types
 */
specials?: SpecialsParameter;
/**
 * position of sponsored hotels in hotelList - 1 means first position in list
 */
sponsoredHotels?: SponsoredHotelsParameter;
/**
 * search for offers with specific attributes on the rooms
 */
roomAttributes?: FilterRoomAttributesParameter;
};

export type GetHotelsSortBy = typeof GetHotelsSortBy[keyof typeof GetHotelsSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetHotelsSortBy = {
  priceAsc: 'priceAsc',
  ratingAsc: 'ratingAsc',
  categoryDesc: 'categoryDesc',
  categoryAsc: 'categoryAsc',
  ratingDesc: 'ratingDesc',
  bd4Desc: 'bd4Desc',
} as const;

export type GetRecommendationsParams = {
/**
 * defines the count of adult persons during the travel.
 */
adults: RecomAdultsParameter;
/**
 * defines a list of airports.
 */
airports?: AirportsParameter;
/**
 * defines the count of children during the travel.
 */
children?: ChildrenParameter;
/**
 * defines the minimum category for the whole travel.
 */
categoryMin?: CategoryMinParameter;
/**
 * defines the first day of vacation.
 */
dateMin: DateMinParameter;
/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 */
dateMax: DateMaxParameter;
/**
 * region id from autocompleter e.g. destination-es-ibiza
 */
destinationId?: string;
/**
 * minimum duration of travel
 */
durationMin?: DurationMinParameter;
/**
 * maximum duration of travel
 */
durationMax?: DurationMaxParameter;
/**
 * defines the travel type.
 */
travelType?: TravelTypeParameter;
/**
 * search/filter for hotel transfer from and to airport, train to the airport (RailAndFly), direct flight or rental car
 */
transportations?: TransportationsParameter;
/**
 * defines a list of tour operators.
 */
tourOperators?: TourOperatorsParameter;
/**
 * defines the filter for board types.
 */
boardTypes?: BoardTypesParameter;
/**
 * filter room types
 */
roomTypes?: RoomTypesParameter;
/**
 * filter room view types
 * @deprecated
 */
roomViews?: RoomViewsParameter;
/**
 * filter hotel attributes like pool,bar,parking lot
 */
hotelAttributes?: HotelAttributesParameter;
/**
 * recommendation placement id
 */
placementId?: string;
/**
 * recommendation tracking userid
 */
userId?: string;
/**
 * base url for the clickout links
 */
baseUrl?: string;
limit?: number;
};

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

/**
 * @summary get categories to filter hotels
 */
export type getHotelInventoryResponse200 = {
  data: HotelInventoryResponse
  status: 200
}

export type getHotelInventoryResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getHotelInventoryResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getHotelInventoryResponseComposite = getHotelInventoryResponse200 | getHotelInventoryResponse400 | getHotelInventoryResponseDefault;
    
export type getHotelInventoryResponse = getHotelInventoryResponseComposite & {
  headers: Headers;
}

export const getGetHotelInventoryUrl = (params: GetHotelInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/hotel/inventory?${stringifiedParams}` : `/hotel/inventory`
}

export const getHotelInventory = async (params: GetHotelInventoryParams, options?: RequestInit): Promise<getHotelInventoryResponse> => {
  
  return adapter<getHotelInventoryResponse>(getGetHotelInventoryUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get paginated, filtered and sorted hotel IDs with meta information for the given destinationId
 */
export type getHotelsResponse200 = {
  data: HotelsResponse
  status: 200
}

export type getHotelsResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getHotelsResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getHotelsResponseComposite = getHotelsResponse200 | getHotelsResponse400 | getHotelsResponseDefault;
    
export type getHotelsResponse = getHotelsResponseComposite & {
  headers: Headers;
}

export const getGetHotelsUrl = (params: GetHotelsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/hotels?${stringifiedParams}` : `/hotels`
}

export const getHotels = async (params: GetHotelsParams, options?: RequestInit): Promise<getHotelsResponse> => {
  
  return adapter<getHotelsResponse>(getGetHotelsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary retrieve recommendation of hotels from BD4 Travel
 */
export type getRecommendationsResponse200 = {
  data: RecommendationsResponse
  status: 200
}

export type getRecommendationsResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getRecommendationsResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getRecommendationsResponseComposite = getRecommendationsResponse200 | getRecommendationsResponse400 | getRecommendationsResponseDefault;
    
export type getRecommendationsResponse = getRecommendationsResponseComposite & {
  headers: Headers;
}

export const getGetRecommendationsUrl = (params: GetRecommendationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/recommendations?${stringifiedParams}` : `/recommendations`
}

export const getRecommendations = async (params: GetRecommendationsParams, options?: RequestInit): Promise<getRecommendationsResponse> => {
  
  return adapter<getRecommendationsResponse>(getGetRecommendationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
